




































import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import EditOnClickField from '@/components/util/EditOnClickField.vue';
import { mapGetters } from 'vuex';
import { PropertiesApi, Property, WorkordersApi } from 'performo-api';
import Location2Picker from '@/components/system/Location2Picker.vue';
import Location2DisplayComponent from '@/components/system/Location2DisplayComponent.vue';

@Component({
  components: { EditOnClickField, Location2Picker, Location2DisplayComponent },
  computed: mapGetters({
    ordersApi: 'ordersApi',
    propertiesApi: 'propertiesApi'
  })
})
export default class SuiteEditor extends Vue {
  @Prop({ required: true, type: String, default: '' })
  private workorderId!: string;

  @Prop({ required: false, default: false })
  private canEdit!: boolean;

  @Prop({ required: true, default: '' })
  private value!: string | number | undefined;

  @Prop({ required: false, default: undefined })
  private buildingCode!: string;

  @Prop({ required: false, default: undefined })
  private floorCode!: string;

  @Prop({ required: true, default: undefined })
  private propertyId!: string;

  private suiteMode = 'read';

  private updatedValue: string | number | undefined = undefined;
  private loading!: boolean;

  private property: Property = {};

  private propertiesApi!: PropertiesApi;
  private ordersApi!: WorkordersApi;

  data() {
    return { updatedValue: this.value, loading: false };
  }

  private get location2Label() {
    return this.property?.location2Label;
  }

  @Watch('propertyId', { immediate: true })
  private async propertyIdChanged() {
    this.property = await this.propertiesApi.getProperty({
      propertyId: this.propertyId
    });
  }

  @Watch('buildingCode')
  @Watch('floorCode')
  private resetFloorValue() {
    this.valueUpdate = '';
  }

  get valueUpdate() {
    return this.updatedValue || this.value;
  }
  set valueUpdate(val) {
    this.updatedValue = val;
  }

  private async handleSuiteChange(suite: string) {
    // update if we have an order
    if (!this.workorderId) {
      return;
    }

    // don't do anything if the new value is the same as the input
    if (this.value === suite) {
      this.exitEdit();
      return;
    }

    // set loading
    this.loading = true;

    // perform api call
    try {
      const updated = await this.ordersApi.changeLocation({
        workorderId: this.workorderId,
        changeOrderLocationCommand: {
          newLocation2: suite
        }
      });
      this.$emit('input', updated);
    } catch (error) {
      this.$emit('error', error);
    }

    // finally exit
    this.exitEdit();
  }

  private exitEdit() {
    // revert to display mode
    this.suiteMode = 'read';
    this.loading = false;
  }
}
